// @ts-nocheck
import { CheckboxProps } from "@insite/mobius/Checkbox";
import { CheckboxGroupProps } from "@insite/mobius/CheckboxGroup";
import { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import { RadioProps } from "@insite/mobius/Radio";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { visuallyHiddenStyles } from "@toolkit/Themes/common/mixins";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import AlertCircle from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleLine";
import { css } from "styled-components";
import { formFieldLabelStyles } from "@store/Themes/common/mixins/formField";

export interface FilterDrawerProps {
    checkbox?: CheckboxProps;
    checkboxGroupWithoutLabel?: CheckboxGroupProps;
    checkboxTooltip?: TooltipPresentationProps;
    dynamicDropdown?: DynamicDropdownPresentationProps;
    fieldWrapper?: InjectableCss;
    radio?: RadioProps;
    textField?: TextFieldPresentationProps;
    toggleCheckbox?: CheckboxProps;
    toggleCheckboxDescription?: TypographyPresentationProps;
    subLabel?: TypographyPresentationProps;
}

export const filterDrawerProps: FilterDrawerProps = {
    checkbox: {
        mergeCss: true,
        css: css`
            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) + label {
                color: ${getColor("primary")};
            }
        `,
    },
    checkboxGroupWithoutLabel: {
        labelProps: {
            css: visuallyHiddenStyles(),
        },
    },
    checkboxTooltip: {
        iconProps: {
            src: AlertCircle,
        },
    },
    dynamicDropdown: { sizeVariant: "small" },
    fieldWrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(12))}
        `,
    },
    radio: {
        mergeCss: true,
        css: css`
            input:checked:not(:disabled) + label {
                color: ${getColor("primary")};
            }
        `,
    },
    textField: { sizeVariant: "small" },
    toggleCheckbox: {
        variant: "toggle",
        sizeVariant: "large" as any,
        labelPosition: "right",
        typographyProps: {
            css: css`
                font-weight: ${x => x.theme.design.typography.weight.bold};
                line-height: 1.4;
                transition: ${transitionHoverStyles("color")};
            `,
        },
        mergeCss: true,
        css: css`
            [role="checkbox"][aria-checked="true"] + label {
                color: ${getColor("primary")};
            }
        `,
    },
    toggleCheckboxDescription: {
        css: css`
            display: block;
            margin-top: ${pxToRem(4)};
            color: ${getColor("text.light")};
            font-size: ${x => x.theme.design.typography.size.smaller};
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
    subLabel: {
        css: css`
            ${formFieldLabelStyles()}
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
};
